import { useState } from "react";
import { Lock } from "lucide-react";

export function ZoneCounter({ count }) {
  return (
    <div data-testid="zone-counter" className="flex items-center justify-between gap-3">
      <p className="text-[14px] font-medium text-ink" data-testid="zone-counter-text">
        <span className="num">{count}</span> {count > 1 ? "zones débloquées" : "zone débloquée"} sur <span className="num">4</span>
      </p>
      <div className="flex gap-1" aria-hidden="true">
        {[1, 2, 3, 4].map((i) => (
          <span key={i} data-testid={`zone-segment-${i}`} data-filled={i <= count} className={`h-1.5 w-7 rounded-full transition-colors duration-300 ${i <= count ? "bg-ink" : "bg-line"}`} />
        ))}
      </div>
    </div>
  );
}

export function LockedZone({ n, title, line, children, onOpen }) {
  const [shake, setShake] = useState(0);
  const tap = () => {
    setShake((k) => k + 1);
    onOpen();
  };
  return (
    <button
      type="button"
      onClick={tap}
      data-testid={`zone-${n}-locked`}
      className="group relative w-full overflow-hidden rounded-card border border-line bg-surface px-4 py-5 text-left transition-colors duration-150 hover:border-ink/30 sm:px-5"
      aria-label={`${title}, verrouillée. Créer un compte pour débloquer.`}
    >
      <h2 className="text-[16px] font-semibold tracking-[-0.01em] text-ink" data-testid={`zone-${n}-title`}>
        {title}
      </h2>
      <p className="mt-1 text-[14px] leading-relaxed text-muted" data-testid={`zone-${n}-line`}>
        {line}
      </p>
      <div className="relative mt-4">
        {children}
        <span key={shake} className={`absolute left-1/2 top-1/2 grid h-14 w-14 -translate-x-1/2 -translate-y-1/2 place-items-center rounded-full border border-line bg-surface shadow-modal ${shake ? "lock-shake" : ""}`} data-testid={`zone-${n}-lock`}>
          <Lock className="h-6 w-6 text-ink" strokeWidth={1.75} />
        </span>
      </div>
    </button>
  );
}

export function OpenZone({ n, title, children, opening }) {
  return (
    <section data-testid={`zone-${n}`} className={`rounded-card border border-line bg-surface px-4 py-5 sm:px-5 ${opening ? "zone-open" : ""}`} aria-label={title}>
      <h2 className="text-[16px] font-semibold tracking-[-0.01em] text-ink">{title}</h2>
      <div className="mt-3">{children}</div>
    </section>
  );
}

export const Bars = ({ rows = 3 }) => (
  <div className="flex select-none flex-col gap-3 blur-[3px]" aria-hidden="true">
    {Array.from({ length: rows }).map((_, i) => (
      <div key={i} className="flex items-center gap-3">
        <span className="h-7 w-7 shrink-0 rounded-full bg-surface-2" />
        <div className="flex-1">
          <div className="h-3 rounded-full bg-line" style={{ width: `${70 - i * 12}%` }} />
          <div className="mt-2 h-2.5 w-2/5 rounded-full bg-surface-2" />
        </div>
      </div>
    ))}
  </div>
);
